import Countdown from "@/components/Countdown";
import ImgTag from "@/components/Helpers/ImgTag";

const Index = () => {
  return (
    <div className="relative w-full h-screen overflow-hidden">
      <ImgTag
        src="https://images-r2.dev-almanea.com/web-page-timer.jpg"
        className="max-[991px]:object-cover"
        fill="true"
        alt="BG IMG!"
      />
      <div className="absolute top-[45%] left-1/2 -translate-x-1/2 -translate-y-1/2  min-w-[320px] p-3 rounded-md z-20 ">
        <Countdown date="10-22-2023 09:00:00 am" />
      </div>
    </div>
  );
};

export default Index;
